import type { EinsatzStatus } from "../lib/types";
import { VGTIcon } from "../lib/vgt";

/** Der Fuß einer Einsatzkarte: wo stehe ich, und was kann ich tun.
 *
 *  Eine Zusage ist keine Einbahnstraße — wer krank wird oder verhindert ist,
 *  muss zurückkönnen (Entscheidung 10.08.2026). Deshalb bleibt „Doch absagen"
 *  auch nach der Zusage erreichbar; die App fragt dann nach einem Grund,
 *  erzwingt ihn aber nicht.
 *
 *  `offeneStelle`: eine ausgeschriebene Stelle, auf die man sich noch nicht
 *  gemeldet hat. Zusagen heißt hier „bewerben" — danach wandert der Job in die
 *  eigenen Einsätze und lässt sich von dort auch wieder zurückziehen. */
const LABEL: Record<EinsatzStatus, string> = {
  wartet_auf_helfer: "Kannst du?",
  wartet_auf_inhaber: "Wir melden uns",
  zugesagt: "Du bist dabei",
  abgesagt_von_helfer: "Du hast abgesagt",
  abgelehnt_vom_inhaber: "Diesmal ohne dich",
};

export function EinsatzAntwort({ status, grund, busy, onZusage, onAbsage, offeneStelle }: {
  status?: EinsatzStatus;
  /** Bei einer abgelehnten Bewerbung: was die Bauleitung dazu geschrieben hat. */
  grund?: string;
  busy: boolean;
  onZusage: () => void;
  onAbsage: () => void;
  offeneStelle?: boolean;
}) {
  if (offeneStelle) {
    return (
      <div className="vgt-antwort" onClick={e => e.stopPropagation()}>
        <div className="l is-offen">Hier ist noch Platz — melde dich, wenn du kannst</div>
        <div className="vgt-actions">
          <button className="vgt-cta is-green" disabled={busy} onClick={onZusage}>
            <VGTIcon name="check" /> Ich bin dabei
          </button>
        </div>
      </div>
    );
  }
  const st = status || "wartet_auf_helfer";
  const offen = st === "wartet_auf_helfer";
  const rueckziehbar = st === "zugesagt" || st === "wartet_auf_inhaber";
  return (
    <div className="vgt-antwort" onClick={e => e.stopPropagation()}>
      <div className="vgt-antwort-zeile">
        <div className={"l" + (offen ? " is-offen" : "")}>{LABEL[st]}</div>
        {rueckziehbar && (
          <button className="ab" disabled={busy} onClick={onAbsage}>
            {st === "zugesagt" ? "Absagen" : "Zurückziehen"}
          </button>
        )}
      </div>
      {st === "abgelehnt_vom_inhaber" && grund ? <div className="vgt-antwort-grund">{grund}</div> : null}
      {offen && (
        <div className="vgt-actions">
          <button className="vgt-cta is-green" disabled={busy} onClick={onZusage}>
            <VGTIcon name="check" /> Ich bin dabei
          </button>
          <button className="vgt-cta is-soft" disabled={busy} onClick={onAbsage}>
            Geht leider nicht
          </button>
        </div>
      )}
    </div>
  );
}
